import React from 'react';
import { ButtonBase, Stack } from '@mui/material';
import { theme } from '../../../../../common/styles/theme';
import { EAudioPageTab } from '../components/types';
import { PlayCaptionIcon } from '../../../../../../icons/PlayCaptionIcon';
import { SchoolIcon } from '../../../../../../icons/SchoolIcon';
import { TranslationsIcon } from '../../../../../../icons/TranslationsIcon';
import { EndlessBookIcon } from '../../../../../../icons/EndlessBookIcon';

export interface ILessonTabBarProps {
	value: EAudioPageTab;
	onChange: (tab: EAudioPageTab) => void;
}

const TABS = [
	{ value: EAudioPageTab.RECORDING, label: 'Recording', Icon: PlayCaptionIcon },
	{ value: EAudioPageTab.EXERCISES, label: 'Exercises', Icon: SchoolIcon },
	{ value: EAudioPageTab.WORDS, label: 'Words', Icon: TranslationsIcon },
	{ value: EAudioPageTab.BOOK, label: 'Book', Icon: EndlessBookIcon },
];

// lesson tabs at the bottom on narrow screens; like the desktop tabs, switching one pauses playback
export const LessonTabBar: React.FC<ILessonTabBarProps> = ({ value, onChange }) => {
	return (
		<Stack
			className={'lesson-tab-bar'}
			direction={'row'}
			sx={{
				flexShrink: 0,
				background: theme.palette.common.white,
				borderTop: `1px solid ${theme.palette.grey[200]}`,
			}}
		>
			{TABS.map(({ value: tab, label, Icon }) => {
				const active = tab === value;
				return (
					<ButtonBase
						key={tab || 'recording'}
						onClick={() => onChange(tab)}
						sx={{
							flex: '1 1 0',
							flexDirection: 'column',
							gap: .25,
							py: 1,
							fontSize: '11px',
							color: active ? theme.palette.primary.main : theme.palette.grey[500],
							fontWeight: active ? 600 : 400,

							'.MuiSvgIcon-root': {
								width: theme.spacing(2.5),
								height: theme.spacing(2.5),
							},

							// landscape: icons only
							'@media (max-height: 500px)': {
								py: .75,
								'.lesson-tab-bar__label': { display: 'none' },
							},
						}}
					>
						<Icon />
						<span className={'lesson-tab-bar__label'}>{label}</span>
					</ButtonBase>
				);
			})}
		</Stack>
	);
};
